module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('PinchInQue', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPinchInQue),
      expression: "isShowPinchInQue"
    }],
    attrs: {
      "pinchInText": _vm.pinchInText,
      "pathstep": _vm.pathstep,
      "pinchInShowVoice": false
    },
    on: {
      "pinchOut": _vm.recievePinchOut
    }
  }), _vm._v(" "), _c('PinchInActStore'), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "inner flexrow milestone"
  }, [_c('div', {
    staticClass: "toparea-group"
  }, [_c('div', {
    staticClass: "toparea-mic"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSre),
      expression: "showSre"
    }],
    staticClass: "flexcenter"
  }, [_c('div', {
    staticClass: "item bgdgray bdgreen w300",
    class: {
      textmgray: _vm.isTextGrayStyle
    },
    attrs: {
      "id": "inputarea"
    }
  }, [_c('div', {
    staticClass: "inputarea-speech"
  }, [_vm._v(_vm._s(_vm.sreResponseText))]), _vm._v(" "), _c('div', {
    staticClass: "mic-icon",
    class: _vm.scoreStyle
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon-skip",
    class: {
      disabled: _vm.disableSkipSre
    },
    on: {
      "click": _vm.skipSreQuestion
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "toparea-text"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTile),
      expression: "showTile"
    }],
    staticClass: "flexstretch"
  }, _vm._l((_vm.selectAnswers), function(answer, index) {
    return _c('div', {
      key: index,
      class: ['item w200', _vm.isMobile() ? '' : _vm.getTextFontClassTile(answer.text, _vm.productLanguage)],
      attrs: {
        "id": 'choice_list_' + index
      },
      on: {
        "click": function($event) {
          return _vm.clickAnswer(index)
        },
        "touchstart": function($event) {
          return _vm.onTouchStart(_vm.selectAnswersTexts[answer.confuserIndex][answer.confuserChildIndex])
        },
        "touchend": function($event) {
          return _vm.onTouchEnd()
        },
        "touchmove": function($event) {
          return _vm.onTouchEnd()
        },
        "mousedown": function($event) {
          return _vm.$emit('hintMouseDown', $event)
        },
        "mouseup": function($event) {
          return _vm.$emit('hintMouseUp', $event)
        },
        "mousemove": function($event) {
          return _vm.$emit('hintMouseMove', $event)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getPopupTextElem(_vm.selectAnswersTexts[answer.confuserIndex][answer.confuserChildIndex]))
      }
    }), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showPinchInBtn),
        expression: "showPinchInBtn"
      }],
      staticClass: "icon-pinch-in",
      on: {
        "click": function($event) {
          return _vm.clickPinchInQue(_vm.selectAnswersTexts[answer.confuserIndex][answer.confuserChildIndex])
        }
      }
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "cards-container"
  }, [_c('div', {
    staticClass: "swiper-milestone swiper-container"
  }, [_c('div', {
    staticClass: "card-inner card-voice swiper-wrapper",
    style: (_vm.tileStyles)
  }, [_vm._l((_vm.actSwiper.group), function(group, groupIndex) {
    return [_c('div', {
      key: groupIndex,
      staticClass: "swiper-slide"
    }, [(group.act.length == 1) ? _c('div', [_c('div', {
      staticClass: "card-single flexcenter"
    }, [_c('MilestoneAct', {
      attrs: {
        "act": group.act[0],
        "productLanguage": _vm.productLanguage,
        "scriptSystems": _vm.scriptSystems,
        "presentActIndex": _vm.currentActIndex,
        "currentConfuserIndex": _vm.currentConfuserIndex,
        "answerState": _vm.answerState,
        "showAnswer": _vm.showAnswer,
        "showPinchInBtn": _vm.showPinchInBtn,
        "mode": _vm.pathstep.mode,
        "questionState": _vm.questionState
      },
      on: {
        "childAudioPlay": _vm.childAudioPlay
      }
    })], 1)]) : _c('div', [_c('div', {
      staticClass: "card-multi flexcenter"
    }, _vm._l((group.act), function(act, actIndex) {
      return _c('div', {
        key: actIndex
      }, [_c('MilestoneAct', {
        attrs: {
          "act": act,
          "productLanguage": _vm.productLanguage,
          "scriptSystems": _vm.scriptSystems,
          "presentActIndex": _vm.currentActIndex,
          "currentConfuserIndex": _vm.currentConfuserIndex,
          "answerState": _vm.answerState,
          "showAnswer": _vm.showAnswer,
          "showPinchInBtn": _vm.showPinchInBtn,
          "pathstepMode": _vm.pathstep.mode,
          "questionState": _vm.questionState
        },
        on: {
          "childAudioPlay": _vm.childAudioPlay
        }
      })], 1)
    }), 0)])])]
  })], 2)])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ae3641f0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-ae3641f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/Milestone.vue
// module id = 884
// module chunks = 1